import React, {useState} from 'react';
import classes from './MainCard.module.css';

import helmet from '../../../assets/img/card_image/helmet.png';
import document from '../../../assets/img/card_image/document_search.png';
import document_protect from '../../../assets/img/card_image/document_protect.png';
import corn from '../../../assets/img/card_image/corn.png';
import gear from '../../../assets/img/card_image/gear.png';
import born from '../../../assets/img/card_image/born.png';
import tank from '../../../assets/img/card_image/tank.png';
import iso from '../../../assets/img/card_image/iso_45001.png';
import kosha_ms from '../../../assets/img/card_image/KOSHA-MS.png';


import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Link } from 'react-router-dom';


const BoxCard = props => {
    return (
        <Paper elevation={1} className={classes.BoxCard}>
            <img src={props.img} alt={props.img} className={classes.image}/>
            <Typography variant="description" component="p" textAlign="center" sx={{marginBottom: '0.625rem'}}>{props.title}</Typography>
            <Button variant="outlined" size="small">
                <Link to={props.url} style={{textDecoration: 'none', color: "inherit"}}>자세히</Link>
            </Button>
        </Paper>
    )
}

const MainCard = () => {
    const [expanded, setExpanded] = useState(false);
    const moreClickHandler = () => {
        setExpanded(!expanded);
    }
    return (
        <>
            <Container 
            maxWidth="md" 
            className={expanded ? `${classes['card-area']} ${classes['expanded']}` : classes['card-area']}
            >
                {/* <Box className={classes['card-area']}> */}
                    <Grid container  spacing={2} >
                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={helmet} 
                                title="안전관리업무위탁"
                                url="/content_01"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={document} 
                                title="안전관리기술지도"
                                url="/content_02"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={document_protect} 
                                title="유해위험방지계획서"
                                url="/content_03"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={corn} 
                                title="위험성평가"
                                url="/content_04"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={tank} 
                                title="공정안전보고서"
                                url="/content_05"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={gear} 
                                title="자율안전확인신고"
                                url="/content_06"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={born} 
                                title="근골격계유해요인조사"
                                url="/content_07"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={iso} 
                                title="ISO45001 인증"
                                url="/content_08"
                            />
                        </Grid>

                        <Grid xs={6} sm={4} md={3}>
                            <BoxCard 
                                img={kosha_ms} 
                                title="KHOSHA-MS 인증"
                                url="/content_09"
                            />
                        </Grid>
                    </Grid>
                {/* </Box> */}
            </Container>

            <Typography 
                className={classes['btn-more']} 
                variant="description" component="p" 
                textAlign="center" 
                color="primary"
                onClick={moreClickHandler}
                marginTop="2rem"
                >
                    {expanded ? '숨기기': '더보기'}
            </Typography>
        </>
    )
}

export default MainCard;